import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from "./CaseActivityCard.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import caseStates from "@_configs/caseStates.config";
import {
  formatDatetime,
  unEscapeHTML,
  shortnString,
  getUserDataFromJwt,
  createNameFromMimeAndChecksum,
  sanitizeHtml,
  handleError,
} from "@_utils/helpers";
import {
  DescriptionOutlined,
  EmailOutlined,
  ExitToAppOutlined,
  ExpandMore,
  MarkunreadMailboxOutlined,
  MoreHoriz,
  PaymentsOutlined,
  Policy,
  PushPin,
  TimerOffTwoTone,
  Warning,
} from "@mui/icons-material";
import {
  Button,
  Chip,
  DialogActions,
  ListItem,
  Menu,
  MenuItem,
  SvgIcon,
  Tooltip,
} from "@mui/material";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import { useDispatch, useSelector } from "react-redux";
import { caseActivityActions } from "@_actions/caseActivity.actions";
import { customerService } from "@_services/customer.service";
import AreYouSurePopup from "@_components/popups/AreYouSurePopup/AreYouSurePopup";
import RenderPopup from "@_components/popups/RenderPopup/RenderPopup";
import { caseConstants } from "@_constants/case.constants";
import { caseActions } from "@_actions/case.actions";
import { emailConstants } from "@_constants/email_flows.constants";
import { invoiceTemplateActions } from "@_actions/invoiceTemplate.actions";
import { invoiceTemplateConstants } from "@_constants/invoiceTemplate.constants";
import "scrollbar.css";
import ChangeOpponentContactDetailsPopup from "@_components/popups/ChangeOpponentContactDetailsPopup.js/ChangeOpponentContactDetailsPopup";
import SelectPopup from "@_components/popups/SelectEmailTemplatePopup/SelectPopup";
import { templateService } from "@_services/template.service";
import InfoPopup from "@_components/popups/InfoPopup/InfoPopup";
import { lettersActions } from "@_actions/letters.actions";
import { PingenLetterStatusLabels } from "@_configs/LetterSendingConfig";
import LicensePopup from "@_components/popups/LicensePopup/LicensePopup";
import { LicenseConstants } from "@_constants/license.constants";
import { casesActions } from "@_actions/cases.actions";
import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";

function CaseActivityCard(props) {
  const { activity, deleteNote, caseData, resumeAutomation, emailTemplates } =
    props;

  const dispatch = useDispatch();
  const caseActivityReducer = useSelector((state) => {
    return state.caseActivityReducer;
  });

  const jwtData = getUserDataFromJwt();
  const anchorRef = React.useRef(null);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [hightClass, setHightClass] = useState(false);
  const [isReplyPopupOpen, setIsReplyPopupOpen] = useState(false);
  const [showAttachements, setShowAttachements] = useState(false);
  const [mailLoaded, setMailLoaded] = useState(false);
  const [openRenderPopup, setOpenRenderPopup] = useState(false);
  const [emailData, setEmailData] = useState({});
  const [openInvoiceMenu, setOpenInvoiceMenu] = useState(false);
  const [openAreyouSurePopup, setOpenAreYouSurePopup] = useState(false);
  const [areYouSurePopupText, setAreYouSurePopupText] = useState("");
  const [areYouSurePopupAction, setAreYouSurePopupAction] = useState({});
  const [
    openChangeOpponentContentDetailsPopup,
    setOpenChangeOpponentContentDetailsPopup,
  ] = useState(false);
  const [openSelectEmailTemplatePopup, setOpenSelectEmailTemplatePopup] =
    useState(false);
  const [openInfoPopup, setOpenInfoPopup] = useState(false);
  const [openCheckLicensePopup, setOpenCheckLicensePopup] = useState(false);
  const { snackbarProps, showSnackbarError } = useSnackbar();

  const emailSetupReducer = useSelector((state) => state.emailSetupReducer);
  const emailSetup = emailSetupReducer.email_setup.active_email_setup;
  const caseReducer = useSelector((state) => state.caseReducer);
  /**
   * To avoid loading the activity again by opening, this
   * overwrites the unread property of activity when
   * user opens to read.
   */
  const [unreadUpdated, setUnreadUpdated] = useState(false);

  var replyToAll = useRef(false);

  const getEmailStringFromEmailObject = (input) => {
    var retval = "";
    if (Array.isArray(input)) {
      retval = input.map((x) => x.address).join(", ");
      return retval;
    }

    return input;
  };

  /**
   * Sets the icon in the upper left corner of the row
   * @returns
   */
  const renderIcon = () => {
    let icon = null;
    switch (activity.type) {
      case caseConstants.CASEACTIVITY_TYPE_NOTE:
        icon = (
          <>
            <SvgIcon
              children={
                <>
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path>
                  <path d="m15.08 11.03-2.12-2.12L7 14.86V17h2.1zm1.77-1.76c.2-.2.2-.51 0-.71l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06z"></path>
                </>
              }
            ></SvgIcon>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT:
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_IN:
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED:
        icon = (
          <>
            <EmailOutlined />
            {activity.content.status ===
              caseConstants.CASE_ACTIVITY_STATE_FAILED && (
              <Tooltip title="Failed to send Email">
                <Warning className={styles.warning_icon} />
              </Tooltip>
            )}
            {activity.content.status ===
              caseConstants.CASE_ACTIVITY_STATE_PAUSED && (
              <Tooltip title="Automation paused">
                <TimerOffTwoTone className={styles.icon} />
              </Tooltip>
            )}
            {activity.content &&
              activity.content.unread === 1 &&
              !unreadUpdated && <div className={styles.unread_marker}></div>}
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_LINK_CLICKED:
      case caseConstants.CASEACTIVITY_TYPE_BILLING_ADDR_SET:
      case caseConstants.CASEACTIVITY_TYPE_LOGIN:
        icon = (
          <>
            <ExitToAppOutlined></ExitToAppOutlined>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_SUCCEEDED:
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_INITIATED:
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_FAILED:
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED:
        icon = (
          <>
            <PaymentsOutlined></PaymentsOutlined>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED:
        icon = (
          <>
            <DescriptionOutlined></DescriptionOutlined>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_LETTER_SENT:
        icon = (
          <>
            <MarkunreadMailboxOutlined></MarkunreadMailboxOutlined>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_STATE_CHANGE:
        icon = (
          <>
            <SvgIcon
              children={
                <path d="M3 11c0 2.45 1.76 4.47 4.08 4.91l-1.49-1.49L7 13l4 4.01L7 21l-1.41-1.41 1.58-1.58v-.06C3.7 17.54 1 14.58 1 11c0-3.87 3.13-7 7-7h3v2H8c-2.76 0-5 2.24-5 5zm19 0V4h-9v7h9zm-2-2h-5V6h5v3zm-7 4h9v7h-9z"></path>
              }
            ></SvgIcon>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_CASE_CREATED:
        icon = (
          <>
            <SvgIcon
              children={
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"></path>
              }
            />
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_UPLOADED:
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_ACCEPTED:
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_REJECTED:
        icon = (
          <>
            <Policy
              className={
                activity.priority === "HIGH"
                  ? styles.license_icon_high
                  : undefined
              }
            />
          </>
        );
        break;
      default:
        break;
    }

    return icon;
  };

  /**
   * Sets the Text next to the icon in the upper part of the row
   * @returns
   */
  const renderTypeText = () => {
    let text = null;
    switch (activity.type) {
      case caseConstants.CASEACTIVITY_TYPE_NOTE:
        text = <>Note</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT:
        text = <>Email sent</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_IN:
        text = <>Email received</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_LINK_CLICKED:
        text = <>Portal Visit</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_LOGIN:
        text = <>Portal Login</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_BILLING_ADDR_SET:
        text = <>Checkout initiated</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_SUCCEEDED:
        text = <>Payment succeeded</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_STATE_CHANGE:
        text = <>State changed</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_FAILED:
        text = <>Payment failed</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED:
        text = <>Payment received</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED:
        text =
          activity.content.type ===
          invoiceTemplateConstants.INVOICE_TYPE_CANCELLATION ? (
            <>Cancellation Invoice</>
          ) : (
            <>Invoice</>
          );
        break;
      case caseConstants.CASEACTIVITY_TYPE_LETTER_SENT:
        text = <span>Letter </span>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_INITIATED:
        text = <>Payment initiated</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_CASE_CREATED:
        text = <>Case created</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED:
        text =
          activity.content.type &&
          activity.content.type ===
            caseConstants.CASEACTIVITY_TYPE_TRIGGERED ? (
            <>Triggered Email </>
          ) : (
            <>Scheduled Email </>
          );
        break;
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_UPLOADED:
        text = <>License uploaded</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_ACCEPTED:
        text = <>License accepted</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_REJECTED:
        text = <>License rejected</>;
        break;
      default:
        text = <></>;
        break;
    }

    return text;
  };

  const renderTypeSubText = () => {
    var retval = <></>;
    switch (activity.type) {
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED:
        retval = (
          <div className={styles.type_subtext_scheduled_template}>
            {activity.content.template_name}
          </div>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT:
        if (
          activity.content?.automation_info?.type ===
            caseConstants.CASEACTIVITY_TYPE_SCHEDULED ||
          (activity.content?.automation_info?.type ===
            caseConstants.CASEACTIVITY_TYPE_TRIGGERED &&
            activity.content?.automation_info?.trigger_event ===
              emailConstants.TRIGGER_EVENT_DISOUNT_END)
        ) {
          retval = <>automated</>;
        } else retval = <>{activity.user_name}</>;
        break;

      case caseConstants.CASEACTIVITY_TYPE_LETTER_SENT:
        retval = <>{activity.user_name}</>;
        break;

      case caseConstants.CASEACTIVITY_TYPE_LICENSE_UPLOADED:
        retval = <>{activity.user_name || "Website owner"}</>;
        break;

      default:
        retval = <>{activity.user_name}</>;
    }
    return retval;
  };

  const toStateName = (state) => {
    return caseStates[state].name;
  };

  const renderContent = () => {
    let content = null;
    switch (activity.type) {
      case caseConstants.CASEACTIVITY_TYPE_NOTE:
        if (detailsModalOpen) {
          content = (
            <>
              <div>
                {unEscapeHTML(activity.content.text)
                  .replace(/[\r\n]+$/, "")
                  .split(/(?:\r\n|\r|\n)/g)
                  .map((str, index) => {
                    return (
                      <div className={styles.note_line} key={index}>
                        {str}
                      </div>
                    );
                  })}
              </div>
            </>
          );
        } else {
          content = (
            <div className={styles.note_collapsed_wrapper}>
              {renderNoteShortened(activity)}
            </div>
          );
        }
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT:
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_IN:
        if (detailsModalOpen) {
          content = (
            <>
              <div className={styles.content_email_meta}>
                {" "}
                {activity.content.to
                  ? Array.isArray(activity.content.to)
                    ? activity.content.to[0].address
                    : activity.content.to
                  : Array.isArray(activity.content.from)
                    ? activity.content.from[0].address
                    : activity.content.from}
              </div>
              <div
                className={styles.content_subject_expanded}
                title={activity.content.subject}
              >
                {activity.content.subject}
              </div>
            </>
          );
        } else {
          content = (
            <>
              {" "}
              <div className={styles.content_email_meta}>
                {" "}
                {activity.content.to
                  ? Array.isArray(activity.content.to)
                    ? activity.content.to[0].address
                    : activity.content.to
                  : Array.isArray(activity.content.from)
                    ? activity.content.from[0].address
                    : activity.content.from}
              </div>
              <div
                className={styles.content_subject_ellipsis}
                title={activity.content.subject}
              >
                {activity.content.subject}
              </div>
            </>
          );
        }
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED:
        content = (
          <>
            {" "}
            <div className={styles.content_email_meta}>
              {" "}
              {caseData?.opponent_contact_details?.email
                ? caseData?.opponent_contact_details?.email
                : ""}
            </div>
            <div
              className={styles.content_subject_ellipsis}
              title={activity.content.template_subject}
            >
              {activity.content.mail_content
                ? activity.content.mail_content.subject
                : activity.content.template_subject}
            </div>
          </>
        );

        break;
      case caseConstants.CASEACTIVITY_TYPE_LETTER_SENT:
        content = (
          <>
            <div>
              {activity?.content?.letter_status && (
                <div className={styles.letter_status_flex_row}>
                  <div className={styles.letter_status_text}>
                    Status:{" "}
                    {activity.content.letter_status === "action_required" &&
                    !activity.content.provider_id
                      ? PingenLetterStatusLabels.resent
                      : PingenLetterStatusLabels[
                          activity?.content?.letter_status
                        ] || "Unknown"}
                  </div>

                  <div className={styles.letter_fail_reason}>
                    {activity?.content?.fail_reason}
                  </div>
                </div>
              )}
              <div
                className={styles.content_subject_ellipsis}
                title={activity.content.template_subject}
              >
                {activity.content.template_name || activity.content.subject}
              </div>
            </div>
          </>
        );

        break;
      case caseConstants.CASEACTIVITY_TYPE_LINK_CLICKED:
        content = <>The website owner visited the settlement portal</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_LOGIN:
        content = <>The website owner logged into the settlement portal</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_BILLING_ADDR_SET:
        content = <>The website owner has started the checkout process</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_STATE_CHANGE:
        content = (
          <>
            <span>
              From {toStateName(activity.content.old_state)} to{" "}
              <b>{toStateName(activity.content.new_state)}</b>
            </span>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_FAILED:
        content = <>{activity.content.message}</>;
        break;
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED:
        content = (
          <>
            <div>
              <strong>
                Total: {activity.content.amount} {activity.content.currency}
              </strong>
            </div>
            <div className={styles.content_secondary_line}>
              payment method:{" "}
              {activity.content.payment_method
                ? activity.content.payment_method
                : "Unknown"}
            </div>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED:
        content = (
          <>
            <div>
              {activity.content.invoice_number}{" "}
              {` ${
                activity.content.type ===
                invoiceTemplateConstants.INVOICE_TYPE_CANCELLED
                  ? "(Cancelled)"
                  : ""
              }`}
            </div>
            {activity.content.type ===
              invoiceTemplateConstants.INVOICE_TYPE_CANCELLATION && (
              <div>
                Cancelled invoice: {activity.content.cancelled_invoice_number}
              </div>
            )}
            {activity.content.type ===
              invoiceTemplateConstants.INVOICE_TYPE_CANCELLED && (
              <div>
                Cancellation invoice:{" "}
                {activity.content.cancellation_invoice_number}
              </div>
            )}
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_UPLOADED: {
        const filename = activity.content.filename;
        const url = activity.content.url;
        content = (
          <div className={styles.license_content}>
            <div className={styles.license_filename} title={filename}>
              {licenseDeleted ? (
                <span className={styles.license_filename_with_status}>
                  <span className={styles.license_filename_text}>
                    {filename}
                  </span>
                  <span className={styles.license_deleted}> (deleted)</span>
                </span>
              ) : url ? (
                <a
                  className={styles.license_file_link}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {filename}
                </a>
              ) : (
                <span>{filename}</span>
              )}
            </div>
            {licenseUnchecked && (
              <Button
                className={styles.btn_check_license}
                size="small"
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenCheckLicensePopup(true);
                }}
              >
                CHECK LICENSE
              </Button>
            )}
          </div>
        );
        break;
      }
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_ACCEPTED:
      case caseConstants.CASEACTIVITY_TYPE_LICENSE_REJECTED: {
        const licenseFilename = activity.content.license_filename;
        const licenseUrl = activity.content.license_url;
        content = (
          <div className={styles.license_content}>
            <div className={styles.license_filename} title={licenseFilename}>
              {licenseUrl ? (
                <a
                  className={styles.license_file_link}
                  href={licenseUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {licenseFilename}
                </a>
              ) : (
                <span>{licenseFilename}</span>
              )}
            </div>
          </div>
        );
        break;
      }
      case caseConstants.CASEACTIVITY_TYPE_CASE_CREATED:
      default:
        content = <></>;
        break;
    }

    return content;
  };

  const noteDeleteIcon = (
    <div
      className={styles.note_delete_icon_wrapper}
      title={
        jwtData.username !== activity.user_name
          ? "You can only delete notes created by yourself"
          : "Delete note"
      }
    >
      <DeleteIcon
        onClick={(e) => {
          e.stopPropagation();
          if (jwtData.username === activity.user_name) handleDeleteNote();
        }}
        className={
          jwtData.username !== activity.user_name
            ? `${styles.delete_shopping_icon} ${styles.delete_icon_disabled}`
            : styles.delete_shopping_icon
        }
      />
    </div>
  );

  function noteNeedsExpand() {
    if (activity.type !== caseConstants.CASEACTIVITY_TYPE_NOTE) return false;
    const raw = activity.content?.text;
    if (!raw) return false;
    const lines = raw
      .split(/(?:\r\n|\r|\n)/g)
      .filter((line) => line.trim().length > 0);
    if (lines.length > 1) return true;
    return lines.length === 1 && lines[0].length > 51;
  }

  function caseActivityNeedsOpener() {
    return (
      noteNeedsExpand() ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED
    );
  }

  const renderOpener = () => {
    let opener = null;
    switch (activity.type) {
      case caseConstants.CASEACTIVITY_TYPE_NOTE:
        opener = (
          <>
            {noteDeleteIcon}
            {noteNeedsExpand() && (
              <div
                className={styles.opener_expand_wrap}
                onClick={(e) => {
                  e.stopPropagation();
                  if (detailsModalOpen) {
                    setHightClass(false);
                    setTimeout(() => {
                      setDetailsModalOpen(false);
                    }, 650);
                  } else {
                    setHightClass(true);
                    setDetailsModalOpen(true);
                  }
                }}
              >
                <ExpandMore
                  className={`${styles.opener_expand_more} ${
                    detailsModalOpen ? styles.gray : ""
                  }`}
                />
              </div>
            )}
          </>
        );

        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED:
        opener = (
          <>
            <DeleteIcon
              className={styles.delete_shopping_icon}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNote();
              }}
            />
            <div
              className={styles.opener_expand_wrap}
              onClick={() => {
                toggleDetails();
                checkContactDetails();
              }}
            >
              <ExpandMore
                className={`${styles.opener_expand_more} ${
                  detailsModalOpen ? styles.gray : ""
                }`}
              />
            </div>
          </>
        );
        break;
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT:
      case caseConstants.CASEACTIVITY_TYPE_EMAIL_IN:
      case caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED:
        opener = (
          <div
            className={styles.opener_expand_wrap}
            onClick={() => {
              toggleDetails();
              checkContactDetails();
            }}
          >
            <ExpandMore
              className={`${styles.opener_expand_more} ${
                detailsModalOpen ? styles.gray : ""
              }`}
            />
          </div>
        );
        break;
      default:
        opener = <></>;
        break;
    }

    return opener;
  };

  const onReplyClicked = () => {
    setIsReplyPopupOpen(true);
  };

  const onMarkUnreadClicked = () => {
    dispatch(
      caseActivityActions.markUnread(
        activity.content.email_id,
        activity.case_id,
      ),
    );
    setUnreadUpdated(false);
    setDetailsModalOpen(false);
  };

  const onShowAttachementsClicked = () => {
    setShowAttachements(true);
  };

  /**
   * After "mark unread" succeeds, clear email state and reset mail loading.
   *
   * Closes detail modal, resets content fetch flag, and cleans up Redux status
   * to allow next mark-unread to work properly.
   *
   */
  useEffect(() => {
    if (caseActivityReducer.status.EMAIL_UNREAD === "success") {
      dispatch(caseActivityActions.clearState("EMAIL_UNREAD"));
      dispatch(caseActivityActions.clearState("EMAIL_CONTENT"));
      setMailLoaded(false);
      //dispatch(caseActivityActions.getCaseActivities(activity.case_id));
    }
  }, [activity.case_id, caseActivityReducer.status.EMAIL_UNREAD, dispatch]);

  /**
   * Closes compose/reply popups when a letter or email send completes successfully (global case reducer).
   *
   * @dependencies
   * - caseReducer.status.CASE_SEND_LETTER, CASE_SEND_EMAIL
   *
   * @triggers
   * When either send status becomes "success".
   *
   * @user_flow
   * 1. User sends an email or letter from this card’s popup.
   * 2. On success: close render popup and reply popup.
   *
   * @sideEffects
   * - `setOpenRenderPopup`, `setIsReplyPopupOpen`
   */
  useEffect(() => {
    if (
      caseReducer.status.CASE_SEND_LETTER === "success" ||
      caseReducer.status.CASE_SEND_EMAIL === "success"
    ) {
      setOpenRenderPopup(false);
      setIsReplyPopupOpen(false);
    }
  }, [caseReducer.status.CASE_SEND_LETTER, caseReducer.status.CASE_SEND_EMAIL]);

  /**
   * Fetches full email body when user opens details modal.
   *
   * Only for email activities (in/out). Sets mailLoaded flag BEFORE dispatching
   * to prevent duplicate fetches on re-render.
   * @dependencies
   * - detailsModalOpen, activity.type, activity.content, activity.case_id, mailLoaded, dispatch
   *
   * @triggers
   * When modal opens and content is missing, or related activity fields change while open.
   *
   ## What Could Go Wrong (Simple Words)

  **Issue 1:** Missing Abort for Stale Fetch, If user opens modal, triggers fetch, then quickly closes and reopens, the first fetch might complete and overwrite the second fetch's data.
   */
  useEffect(() => {
    if (
      detailsModalOpen &&
      (activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
        activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT) &&
      activity.content &&
      !activity.content.mail_content &&
      !mailLoaded
    ) {
      setMailLoaded(true); // Set BEFORE dispatch to prevent double-fetch
      dispatch(
        caseActivityActions.getEmailContent(
          activity.content.email_id,
          activity.case_id,
          activity.content.unread > 0,
        ),
      );
    }
  }, [
    detailsModalOpen,
    activity.type,
    activity.content,
    activity.case_id,
    mailLoaded,
    dispatch,
  ]);

  /**
   * When the email details modal closes, reset `mailLoaded` so the next open can fetch fresh content.
   *
   * Pairs with the lazy-load effect above.
   *
   * @dependencies
   * - detailsModalOpen
   *
   * @triggers
   * When modal closes.
   */
  useEffect(() => {
    if (!detailsModalOpen) {
      setMailLoaded(false);
    }
  }, [detailsModalOpen]);

  const renderMailFromContent = () => {
    return (
      <>
        {activity.content.mail_content && (
          <div className={styles.notePopupTextContainer}>
            {(activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
              activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT) && (
              <div className={styles.email_tools}>
                <Button
                  onClick={() => {
                    replyToAll.current = false;
                    onReplyClicked();
                  }}
                  className={
                    activity.type ===
                      caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT
                      ? styles.btn_default
                      : styles.btn_default_invisible
                  }
                >
                  Reply
                </Button>
                <Button
                  onClick={() => {
                    if (
                      emailTemplates?.filter(
                        (template) =>
                          template.type === emailConstants.TEMPLATE_TYPE_CUSTOM,
                      ).length > 0
                    ) {
                      replyToAll.current = false;
                      setOpenSelectEmailTemplatePopup(true);
                    } else {
                      setOpenInfoPopup(true);
                    }
                  }}
                  className={
                    activity.type ===
                      caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT
                      ? styles.btn_default
                      : styles.btn_default_invisible
                  }
                >
                  Reply with template
                </Button>
                {!(
                  activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT
                ) &&
                  ((activity.content.mail_content.to &&
                    activity.content.mail_content.to.length > 1) ||
                    ((typeof activity.content.mail_content.data.cc ===
                      "string" ||
                      (activity.content.mail_content.data.cc &&
                        activity.content.mail_content.data.cc.value.length >
                          0)) && (
                      <Button
                        onClick={() => {
                          replyToAll.current = true;
                          onReplyClicked();
                        }}
                        className={styles.btn_default}
                      >
                        Reply all
                      </Button>
                    )))}

                <Button
                  onClick={() => {
                    onMarkUnreadClicked();
                  }}
                  className={
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN
                      ? styles.btn_default
                      : styles.btn_default_invisible
                  }
                >
                  Mark unread
                </Button>

                {getNumAttachements() > 0 && (
                  <div className={styles.attachment_button_container}>
                    <Button
                      onClick={() => {
                        onShowAttachementsClicked();
                      }}
                      className={styles.btn_default}
                    >
                      <Chip
                        className={styles.attachment_chip}
                        label={getNumAttachements()}
                      ></Chip>
                      Attachments
                    </Button>
                  </div>
                )}
              </div>
            )}

            <iframe
              className={styles.email_iframe}
              csp="script-src 'none'"
              sandbox="allow-popups allow-popups-to-escape-sandbox"
              srcDoc={
                typeof activity.content.mail_content.data.html === "boolean"
                  ? returnSafeHtml(
                      activity.content.mail_content.data.textAsHtml,
                    )
                  : returnSafeHtml(activity.content.mail_content.data.html)
              }
              title="Email Content"
            ></iframe>
          </div>
        )}
        {!activity.content.mail_content && (
          <>
            {caseActivityReducer.status.EMAIL_CONTENT === "failure" ? (
              <div className={styles.mail_status_message}>
                Failed to load mail...
              </div>
            ) : (
              <div className={styles.mail_status_message}>loading...</div>
            )}{" "}
          </>
        )}
      </>
    );
  };

  /**
   * For scheduled-email activities, Prefetches scheduled email template content to show preview in the row.
   *
   * When activity type changes to scheduled email or content updates,
   * fetch template details (subject, body, config) so user can see
   * what will be sent without opening modal.
   */
  useEffect(() => {
    // we request the scheduled mail content from the begining to get the case id in the subject
    // Reset flag on activity change
    setMailLoaded(false);
    if (
      activity.content &&
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED &&
      !activity.content.mail_content
    ) {
      dispatch(
        caseActivityActions.getEmailTemplateContentByTemplate(
          activity.case_id,
          activity.content.source_email_template_id,
          {
            subject: activity.content.template_subject,
            content: activity.content.template_content,
            config: activity.content.template_config,
            id: activity.content.source_email_template_id,
          },
        ),
      );
      setMailLoaded(true);
    }
  }, [activity.content, activity.case_id, activity.type, dispatch]);

  const handleOpenTemplatePopup = (event) => {
    event.stopPropagation();
    setEmailData({
      content: activity?.content.mail_content?.content,
      name: activity?.content?.template_name,
      subject: activity?.content?.mail_content.subject,
      opponentEmail: caseData?.opponent_contact_details?.email,
    });
    setOpenRenderPopup(true);
  };

  const returnSafeHtml = useMemo(() => {
    return (html) => {
      const sanitizedHtml = sanitizeHtml(html);

      return `
      <!doctype html>
      <html>
      <head>
      <base target="_blank" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap" />
        <style>
        body {
          font-family: "Roboto";
          color: #4b4b4b;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;}
          p {
          font-family: "Roboto";
          line-height: 1.6;
          margin-left: 10px;
          font-size:18px;
        }
        </style>
      </head>
      <body>
      ${sanitizedHtml}
      </body>
      </html>
    `;
    };
  }, []);

  const renderMailFromTemplate = () => {
    return (
      <>
        {activity.content.template_content && (
          <div className={styles.notePopupTextContainer}>
            {(activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
              getNumAttachements() > 0) && (
              <div className={styles.email_tools}>
                <Button
                  onClick={() => {
                    replyToAll.current = false;
                    onReplyClicked();
                  }}
                  className={
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN
                      ? styles.btn_default
                      : styles.btn_default_invisible
                  }
                >
                  Reply
                </Button>
                <Button
                  onClick={() => {
                    if (
                      emailTemplates?.filter(
                        (template) =>
                          template.type === emailConstants.TEMPLATE_TYPE_CUSTOM,
                      ).length > 0
                    ) {
                      replyToAll.current = false;
                      setOpenSelectEmailTemplatePopup(true);
                    } else {
                      setOpenInfoPopup(true);
                    }
                  }}
                  className={
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN
                      ? styles.btn_default
                      : styles.btn_default_invisible
                  }
                >
                  Reply with Template
                </Button>
                {((activity.content.mail_content.to &&
                  activity.content.mail_content.to.length > 1) ||
                  (activity.content.mail_content.data.cc &&
                    activity.content.mail_content.data.cc.value.length)) && (
                  <Button
                    onClick={() => {
                      replyToAll.current = true;
                      onReplyClicked();
                    }}
                    className={styles.btn_default}
                  >
                    Reply all
                  </Button>
                )}

                <Button
                  onClick={() => {
                    onMarkUnreadClicked();
                  }}
                  className={
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN
                      ? styles.btn_default
                      : styles.btn_default_invisible
                  }
                >
                  Mark unread
                </Button>

                {getNumAttachements() > 0 && (
                  <div className={styles.attachment_button_container}>
                    <Button
                      onClick={() => {
                        onShowAttachementsClicked();
                      }}
                      className={styles.btn_default}
                    >
                      <Chip
                        className={styles.attachment_chip}
                        label={getNumAttachements()}
                      ></Chip>
                      Attachments
                    </Button>
                  </div>
                )}
              </div>
            )}
            {activity.content.status ===
              caseConstants.CASE_ACTIVITY_STATE_FAILED && (
              <div className={styles.email_resend_container}>
                <p className={styles.resend_text}>
                  Sending email failed :{" "}
                  {activity.content.history.find(
                    (a) => a.event === caseConstants.CASE_ACTIVITY_STATE_FAILED,
                  )?.error_msg || ""}
                </p>

                <Button
                  className={styles.btn_default}
                  onClick={handleOpenTemplatePopup}
                >
                  Resend
                </Button>
              </div>
            )}
            {activity.content.mail_content && (
              <iframe
                className={styles.email_iframe}
                sandbox="allow-popups allow-popups-to-escape-sandbox"
                csp="script-src 'none'"
                srcDoc={returnSafeHtml(activity.content.mail_content.content)}
                title="Email Content"
              ></iframe>
            )}
          </div>
        )}
        {!activity.content.mail_content && (
          <>
            {caseActivityReducer.status.EMAIL_CONTENT === "failure" ? (
              <div className={styles.mail_status_message}>
                Failed to load mail...
              </div>
            ) : (
              <div className={styles.mail_status_message}>loading...</div>
            )}{" "}
          </>
        )}
      </>
    );
  };

  const renderEmail = () => {
    if (activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED)
      return renderMailFromTemplate();
    else return renderMailFromContent();
  };

  const handleOpenResendLetterPopup = () => {
    setAreYouSurePopupText(
      `Make sure you fixed the issue "${activity?.content?.fail_reason}" before resending.\nAre you sure you want to resend the letter?`,
    );
    setAreYouSurePopupAction(() => handleOpenResendRenderPopup);
    setOpenAreYouSurePopup(true);
  };

  const handleOpenResendRenderPopup = () => {
    setOpenAreYouSurePopup(false);
    templateService
      .getCaseTemplate(caseData.id, activity.content.template_id)
      .then(
        (template) => {
          //it doesn't matter because we need the send to address (opponent address) not the writtendown address
          let to = caseData.opponent_contact_details?.email;
          if (caseData.opponent_contact_details) {
            to =
              (caseData.opponent_contact_details.name
                ? caseData.opponent_contact_details.name + ", "
                : "") +
              (caseData.opponent_contact_details.company
                ? caseData.opponent_contact_details.company + ", "
                : "") +
              (caseData.opponent_contact_details.address_line_1
                ? caseData.opponent_contact_details.address_line_1 + ", "
                : "") +
              (caseData.opponent_contact_details.address_line_2
                ? caseData.opponent_contact_details.address_line_2 + ", "
                : "") +
              (caseData.opponent_contact_details.postal_code
                ? caseData.opponent_contact_details.postal_code + " "
                : "") +
              (caseData.opponent_contact_details.city
                ? caseData.opponent_contact_details.city + ", "
                : "") +
              (caseData.opponent_contact_details.country
                ? caseData.opponent_contact_details.country
                : "");
          }
          setEmailData({
            content: template.content,
            name: template.name || "",
            subject: template.subject,
            opponentEmail: to,
            type: emailConstants.TEMPLATE_TYPE_LETTER,
            template_id: activity.content.template_id,
            oldFailedLetterId: activity.content.letter_id,
          });
          // setOpenRenderPopup(true);
          setOpenRenderPopup(true);
        },
        (error) => {
          showSnackbarError(handleError(error));
        },
      );
  };

  const handleDeleteNote = () => {
    setOpenAreYouSurePopup(true);
    setAreYouSurePopupText("Are you sure you want to delete this?");
    setAreYouSurePopupAction(() => deleteActivity);
  };

  const handleCancelPopup = () => {
    setOpenAreYouSurePopup(true);
    setAreYouSurePopupText("Are you sure you want to cancel this invoice ?");
    setAreYouSurePopupAction(() => handleCancelInvoice);
  };

  const deleteActivity = () => {
    setOpenAreYouSurePopup(false);
    setAreYouSurePopupText("");
    setAreYouSurePopupAction({});
    if (activity.type === caseConstants.CASEACTIVITY_TYPE_NOTE) {
      deleteNote(activity);
    } else {
      dispatch(
        caseActivityActions.deleteScheduledMails(activity.case_id, activity.id),
      );
      if (
        activity.content.status === caseConstants.CASE_ACTIVITY_STATE_FAILED
      ) {
        dispatch(
          caseActions.decreaseFailed(
            activity.case_id,
            activity.content.type === caseConstants.CASEACTIVITY_TYPE_TRIGGERED
              ? "num_triggered_emails_failed"
              : "num_scheduled_emails_failed",
          ),
        );
      }
    }
  };

  const selectEmailTemplate = (templateId) => {
    templateService.getCaseTemplate(caseData.id, templateId).then(
      (template) => {
        setEmailData({
          content: template.content,
          name: template.name,
          subject: template.subject,
        });
        setOpenSelectEmailTemplatePopup(false);
        setIsReplyPopupOpen(true);
      },
      (error) => {
        showSnackbarError(handleError(error));
      },
    );
  };

  function toggleDetails() {
    if (
      noteNeedsExpand() ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED ||
      activity.type === caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED
    ) {
      if (detailsModalOpen) {
        setHightClass(false);
        setTimeout(() => {
          setDetailsModalOpen(false);
        }, 650);
      } else {
        setHightClass(true);
        setDetailsModalOpen(true);
      }

      if (activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN) {
        setUnreadUpdated(true);
      }
    }
  }

  const checkContactDetails = () => {
    if (
      activity?.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN &&
      activity?.content?.unread === 1 &&
      activity.content.from[0].address !==
        caseData.opponent_contact_details.email
    ) {
      setOpenChangeOpponentContentDetailsPopup(true);
    }
  };

  const downloadAttachement = (attachement) => {
    customerService
      .downloadAttachement(activity.content.email_id, attachement.checksum)
      /* 
      .catch() comes before .then(response => ...).
      If request fails, catch resolves to undefined, 
      then next .then still runs and response.status throws.
      */
      .catch((e) => {
        showSnackbarError("Can not download. Unauthorized");
      })
      .then((response) => {
        if (response.status !== 200) {
          showSnackbarError("Can not download. Unauthorized");
          return;
        }
        return response.blob();
      })
      .then((blob) => {
        if (!blob) return;
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", attachement.filename);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });
  };

  const handleOpenInvoiceMenu = (event) => {
    event.stopPropagation();
    setOpenInvoiceMenu(true);
  };

  const handleDownloadInvoice = (action) => {
    dispatch(
      invoiceTemplateActions.downloadInvoice(
        activity.case_id,
        activity.content.invoice_id,
        activity.content.invoice_number,
        action,
      ),
    );
  };

  const handleDownloadLetter = (action) => {
    dispatch(
      lettersActions.downloadLetter(
        activity.case_id,
        activity.content.letter_id,
        action,
      ),
    );
  };

  const handleAttachInvoice = () => {
    setEmailData({
      opponentEmail: caseData?.opponent_contact_details?.email,
    });
    setIsReplyPopupOpen(true);
  };

  const handleCancelInvoice = () => {
    dispatch(
      invoiceTemplateActions.cancelInvoice(
        activity.case_id,
        activity.content.invoice_id,
      ),
    );
    setAreYouSurePopupAction("");
    setAreYouSurePopupText("");
    setOpenAreYouSurePopup(false);
  };

  const isLicenseUploadedActivity =
    activity.type === caseConstants.CASEACTIVITY_TYPE_LICENSE_UPLOADED;

  const licenseDeleted =
    isLicenseUploadedActivity && activity.content.state === "DELETED";

  const licenseUnchecked =
    isLicenseUploadedActivity &&
    activity.content.state === LicenseConstants.STATE_UNCHECKED;

  const canDeleteLicense =
    isLicenseUploadedActivity &&
    !licenseDeleted &&
    (caseData?.state === caseConstants.CASE_STATE_ACTIVE ||
      caseData?.state === caseConstants.CASE_STATE_CANCELLED);

  const licenseFinding = isLicenseUploadedActivity
    ? caseData?.findings?.find(
        (f) => f.license && f.license.id === activity.content.license_id,
      )
    : null;

  const handleDeleteLicense = () => {
    setOpenAreYouSurePopup(true);
    setAreYouSurePopupText("Are you sure you want to delete this license?");
    setAreYouSurePopupAction(() => confirmDeleteLicense);
  };

  const confirmDeleteLicense = () => {
    setOpenAreYouSurePopup(false);
    setAreYouSurePopupText("");
    setAreYouSurePopupAction({});
    if (licenseFinding) {
      dispatch(
        caseActions.deleteCaseLicense(
          activity.case_id,
          caseData.findings.indexOf(licenseFinding),
          licenseFinding.id,
        ),
      );
    }
  };

  /**
   * After a license is deleted from a license activity row (`CASE_DELETE_LICENSE` success),
   * sync Redux case, list, and activities.
   * Clear delete status
   * Refresh cases list
   * Refetch current case
   * Refresh activity timeline
   * issue: No Error Handling
   */
  useEffect(() => {
    if (
      isLicenseUploadedActivity &&
      caseReducer.status["CASE_DELETE_LICENSE"] === "success"
    ) {
      dispatch(caseActions.clearStateMessage("CASE_DELETE_LICENSE"));
      dispatch(casesActions.getCases());
      dispatch(
        caseActions.getCaseWithChargeDetails(
          activity.case_id,
          caseData?.overview,
        ),
      );
      dispatch(caseActivityActions.getCaseActivities(activity.case_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseReducer.status["CASE_DELETE_LICENSE"]]);

  const getNumAttachements = () => {
    if (
      !activity ||
      !activity.content ||
      !activity.content.mail_content ||
      !activity.content.mail_content.data ||
      !activity.content.mail_content.data.attachments
    )
      return 0;
    return activity.content.mail_content.data.attachments.length;
  };

  const renderAttachements = () => {
    if (
      !activity ||
      !activity.content ||
      !activity.content.mail_content ||
      !activity.content.mail_content.data ||
      !activity.content.mail_content.data.attachments
    )
      return <>This mail has no attachements</>;

    var retval = [];

    for (const item of activity.content.mail_content.data.attachments) {
      retval.push(
        <>
          <ListItem key={item.checksum}>
            <div className={styles.attachement_row}>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        {item.filename
                          ? item.filename
                          : createNameFromMimeAndChecksum(
                              item.checksum,
                              item.contentType,
                            )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Button
                className={styles.btn_cancel}
                onClick={() => downloadAttachement(item)}
              >
                Download
              </Button>
            </div>
          </ListItem>
        </>,
      );
    }

    return retval;
  };

  return (
    <div>
      <AppSnackbar {...snackbarProps} />
      <div
        className={`${hightClass ? styles.rootAnimation : styles.root} ${
          activity.priority === "HIGH" || activity.priority === "LOW"
            ? styles.priority
            : ""
        } ${props.dottedborder !== undefined ? styles.root_dotted_border : ""}`}
      >
        {activity.priority === "HIGH" || activity.priority === "LOW" ? (
          <Tooltip title="Priority activity">
            <PushPin className={styles.priority_pin} />
          </Tooltip>
        ) : null}
        <div className={styles.rootFlex}>
          <div className={styles.left_container}>
            <div className={styles.left_icon}>{renderIcon()}</div>
            <div className={styles.left_timestamp}>
              {activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED
                ? formatDatetime(activity.content.scheduled_at, "medium")
                : formatDatetime(activity.created, "medium")}
            </div>
          </div>
          <div className={styles.middle_container}>
            <div className={styles.middle_type}>{renderTypeText()}</div>
            <div className={styles.middle_user}> {renderTypeSubText()}</div>
          </div>
          <div
            className={
              caseActivityNeedsOpener()
                ? styles.right_container_opener
                : styles.right_container
            }
            onClick={() => {
              toggleDetails();
              checkContactDetails();
            }}
          >
            {renderContent()}
          </div>
          <div
            className={`${styles.right_opener} ${
              !caseActivityNeedsOpener() ? styles.right_opener_top : ""
            }`}
          >
            {(activity.type ===
              caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED ||
              activity.type ===
                caseConstants.CASEACTIVITY_TYPE_LETTER_SENT) && (
              <>
                <MoreHoriz
                  className={styles.edit_icon}
                  onClick={handleOpenInvoiceMenu}
                  ref={anchorRef}
                  aria-controls={openInvoiceMenu ? "menu-list-grow" : undefined}
                  aria-haspopup="true"
                />
                <Menu
                  open={openInvoiceMenu}
                  anchorEl={anchorRef.current}
                  onClose={() => setOpenInvoiceMenu(false)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    onClick={() =>
                      activity.type ===
                      caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED
                        ? handleDownloadInvoice("view")
                        : handleDownloadLetter("view")
                    }
                  >
                    View
                  </MenuItem>
                  <MenuItem
                    onClick={() =>
                      activity.type ===
                      caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED
                        ? handleDownloadInvoice("download")
                        : handleDownloadLetter("download")
                    }
                  >
                    Download
                  </MenuItem>
                  {activity.type ===
                    caseConstants.CASEACTIVITY_TYPE_LETTER_SENT &&
                    activity.content.letter_status === "action_required" &&
                    PingenLetterStatusLabels.action_required &&
                    activity.content.provider_id && (
                      <MenuItem onClick={handleOpenResendLetterPopup}>
                        Resend
                      </MenuItem>
                    )}
                  {activity.type ===
                    caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED && (
                    <MenuItem onClick={() => handleAttachInvoice()}>
                      Attach to email
                    </MenuItem>
                  )}
                  {activity.content.type ===
                    invoiceTemplateConstants.INVOICE_TYPE_ACTIVE && (
                    <MenuItem onClick={handleCancelPopup}>Cancel</MenuItem>
                  )}
                </Menu>
              </>
            )}
            {isLicenseUploadedActivity && canDeleteLicense && (
              <DeleteIcon
                className={styles.delete_shopping_icon}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteLicense();
                }}
              />
            )}
            {renderOpener()}
          </div>
        </div>
        <div>
          {detailsModalOpen ? (
            activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT ||
            activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
            activity.type ===
              caseConstants.CASEACTIVITY_TYPE_EMAIL_SCHEDULED ? (
              <div className={styles.mailContainer}>{renderEmail()}</div>
            ) : activity.type ===
              caseConstants.CASEACTIVITY_TYPE_PAYMENT_RECEIVED ? (
              <div className={styles.payment_received_container}>
                <div className={styles.payment_received_company_info_block}>
                  <div>
                    <strong
                      className={styles.payment_received_email_block_label}
                    >
                      Company:
                    </strong>
                    {"  "}
                    {activity.content?.billing_address?.name || ""}
                  </div>
                  <div>
                    <strong
                      className={styles.payment_received_email_block_label}
                    >
                      VAT ID:
                    </strong>
                    {"  "}
                    {activity.content?.billing_address?.vat_id || ""}
                  </div>
                  <div>
                    <strong
                      className={styles.payment_received_email_block_label}
                    >
                      Email:
                    </strong>{" "}
                    {activity.content?.billing_address?.email || "-"}
                  </div>
                </div>
                <div className={styles.payment_received_address_block}>
                  <strong>Billing address</strong>
                  <div>
                    {activity.content?.billing_address?.address_line_1 || ""}
                  </div>
                  <div>
                    {activity.content?.billing_address?.address_line_2 || ""}
                  </div>
                  <div>
                    {activity.content?.billing_address?.postal_code
                      ? `${activity.content?.billing_address?.postal_code} - `
                      : ""}{" "}
                    {activity.content?.billing_address?.city || ""}
                  </div>
                  <div>{activity.content?.billing_address?.country || ""}</div>
                </div>
              </div>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </div>
      </div>

      <RenderPopup
        title={`${
          emailData.name === emailConstants.NEW_MAIL
            ? "New mail"
            : "mail preview: " + emailData.name
        }`}
        open={openRenderPopup}
        close={() => {
          setAreYouSurePopupAction({});
          setOpenRenderPopup(false);
        }}
        data={emailData}
        caseId={activity.case_id}
        emailSetup={emailSetup}
        activity={activity}
        isReplyMode={false}
        resumeAutomation={resumeAutomation}
        JwtData={jwtData}
      />

      <AreYouSurePopup
        open={openAreyouSurePopup}
        close={() => setOpenAreYouSurePopup(false)}
        onClick={areYouSurePopupAction}
        isLoading={caseActivityReducer.loading}
      >
        <p className={styles.are_you_sure_preline}>{areYouSurePopupText}</p>
      </AreYouSurePopup>
      <ChangeOpponentContactDetailsPopup
        open={openChangeOpponentContentDetailsPopup}
        close={() => setOpenChangeOpponentContentDetailsPopup(false)}
        from={activity?.content?.from || ""}
        caseData={caseData}
        opponentContactDetails={caseData.opponent_contact_details}
      />
      <SelectPopup
        open={openSelectEmailTemplatePopup}
        close={() => {
          setOpenSelectEmailTemplatePopup(false);
        }}
        selections={emailTemplates?.filter(
          (template) => template.type === emailConstants.TEMPLATE_TYPE_CUSTOM,
        )}
        select={selectEmailTemplate}
        title="Select email template"
      />
      <InfoPopup
        open={openInfoPopup}
        title="NOTICE"
        close={() => setOpenInfoPopup(false)}
      >
        <p>
          This case's email flow does not contain any custom email template.
          <br />
          Here is how you can create one:
          <ul>
            <li>
              Go to{" "}
              <span className={styles.info_popup_emphasis}>
                {"Templates > Email Flows > "}
                {caseData?.email_flow?.name}
              </span>
            </li>
            <li>Click on 'ADD CUSTOM EMAIL'</li>
          </ul>
        </p>
      </InfoPopup>

      {(activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_IN ||
        activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT ||
        activity.type ===
          caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED) && (
        <>
          <RenderPopup
            title={
              activity.type ===
              caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED
                ? "New email"
                : "Reply to " +
                  getEmailStringFromEmailObject(
                    activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT
                      ? activity.content.to
                      : activity.content.from,
                  )
            }
            open={isReplyPopupOpen}
            email={activity.content.mail_content}
            close={() => {
              setIsReplyPopupOpen(false);
              setEmailData({});
            }}
            data={emailData}
            caseId={activity.case_id}
            emailSetup={emailSetup}
            resumeAutomation={resumeAutomation}
            isReplyMode={
              activity.type ===
              caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED
                ? false
                : true
            }
            isSelfReply={
              activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT
            }
            replyToAll={
              replyToAll.current &&
              !(activity.type === caseConstants.CASEACTIVITY_TYPE_EMAIL_OUT)
            }
            JwtData={jwtData}
            invoice={
              activity.type ===
              caseConstants.CASEACTIVITY_TYPE_INVOICE_GENERATED
                ? activity
                : ""
            }
          />

          <DialogPopup
            open={showAttachements}
            onClose={() => setShowAttachements(false)}
            title={
              'Attachments of: "' +
              shortnString(activity.content.subject, 50) +
              '"'
            }
          >
            <div className={styles.dialogContent}>{renderAttachements()}</div>
            <DialogActions className={styles.dialog_actions_compact}>
              <Button
                onClick={() => setShowAttachements(false)}
                className={styles.btn_cancel}
              >
                Close
              </Button>
            </DialogActions>
          </DialogPopup>
        </>
      )}

      {isLicenseUploadedActivity && (
        <LicensePopup
          open={openCheckLicensePopup}
          close={() => setOpenCheckLicensePopup(false)}
          data={caseData}
          caseId={activity.case_id}
          filterLicenseId={activity.content.license_id}
          resumeAutomation={resumeAutomation}
        />
      )}
    </div>
  );
}

export default CaseActivityCard;

function renderNoteShortened(activity) {
  return unEscapeHTML(activity.content.text)
    .replace(/[\r\n]+$/, "")
    .split(/(?:\r\n|\r|\n)/g)
    .map((str, index) => {
      if (index <= 1) {
        return (
          <div className={styles.note_line_truncated} key={index}>
            {str}
          </div>
        );
      }

      return null;
    })
    .filter(Boolean);
}
